module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.togglePlaceholderOn),
      expression: "togglePlaceholderOn"
    }]
  }, [_c('input', {
    ref: "input",
    class: _vm.placeholderOn ? '' : 'expanded',
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        _vm.setSearchQuery($event.target.value)
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.togglePlaceholder($event)
      }],
      "focus": _vm.togglePlaceholder,
      "blur": _vm.togglePlaceholder
    }
  }), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.submit
    }
  }, [_c('img', {
    attrs: {
      "src": require("./Search.svg"),
      "width": "20",
      "height": "20"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-450f8930"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SearchModule.vue
// module id = 774
// module chunks = 1